// よくある質問サイドバーアコーディオン
jQuery(function ($) {
  const mediaQuery = window.matchMedia('(max-width: 768px)');

  // サイドバー全体：SPのみ開閉
  $('.js-faqSidebar-toggle').on('click', function () {
    if (!mediaQuery.matches) return;

    const $button = $(this);
    const $content = $button
      .closest('.js-faqSidebar')
      .find('.js-faqSidebar-content');

    const isOpen = $button.attr('aria-expanded') === 'true';

    $button.attr('aria-expanded', String(!isOpen));
    $button.toggleClass('is-open', !isOpen);
    $content.stop(true, true).slideToggle(300);
  });

  // 親カテゴリー：PC・SP共通
  $('.js-faqCategory-toggle').on('click', function () {
    const $button = $(this);
    const $children = $button
      .closest('.cat-item-parent')
      .children('.children');

    const isOpen = $button.attr('aria-expanded') === 'true';

    $button.attr('aria-expanded', String(!isOpen));

    // 開閉状態に応じてis-openを付け外し
    $button.toggleClass('is-open', !isOpen);
    $children.toggleClass('is-open', !isOpen);

    $children.stop(true, true).slideToggle(300);
  });

  // 子カテゴリー・単独カテゴリー：ページ内スクロール
  $('.js-faqCategory-link').on('click', function (e) {
    e.preventDefault();

    const categoryId = $(this).attr('data-category');

    const $target = $('.js-faqGroup').filter(function () {
      return $(this).attr('data-category') === categoryId;
    });

    if (!$target.length) return;

    $('html, body').stop().animate({
      scrollTop: $target.offset().top - 120
    }, 400);
  });

  // FAQの質問・回答
  $('.js-faqCard-toggle').on('click', function () {
    const $button = $(this);
    const $body = $button.next('.js-faqCard-contents');

    const isOpen = $button.attr('aria-expanded') === 'true';

    $button.attr('aria-expanded', String(!isOpen));
    $body.stop(true, true).slideToggle(300);
  });

  // PC・SPの切り替え
  const handleBreakpoint = () => {
    const $content = $('.js-faqSidebar-content');
    const $button = $('.js-faqSidebar-toggle');

    $content.stop(true, true).removeAttr('style');

    if (mediaQuery.matches) {
      // SP
      $content.hide();
      $button.attr('aria-expanded', 'false');
      $button.removeClass('is-open');
    } else {
      // PC
      $button.attr('aria-expanded', 'true');
      $button.removeClass('is-open');
    }
  };

  mediaQuery.addEventListener('change', handleBreakpoint);
  handleBreakpoint();
});